export default "__VITE_ASSET__CM5bl72D__"